<div class="message">
  <% visit_types.forEach(function(visit_type) { %>
    <dl class="visit-type-definition-list">
    <% if (returning_patient ? visit_type.valid_for_returning_patient : visit_type.valid_for_new_patient) { %>
      <dt>
        <i class="icon icon-<%- visit_type.category %>-visit" ></i><%- visit_type.name %>
      </dt>
      <dd><%= visit_type.help %></dd>
    <% } %>
    </dl>
  <% }) %>
</div>
